import { create } from "zustand";

interface MapState {
  center: [number, number];
  zoom: number;
  selectedFeatureId: string | null;
  visibleLayers: Record<string, boolean>;
  setCenter: (center: [number, number]) => void;
  setZoom: (zoom: number) => void;
  setSelectedFeatureId: (id: string | null) => void;
  toggleLayer: (layerKey: string) => void;
}

export const useMapStore = create<MapState>((set) => ({
  center: [37.5, 14.0],
  zoom: 8,
  selectedFeatureId: null,
  visibleLayers: {
    incendio: true,
    sitac: true,
    squadre: true,
    mezzi: true,
    puntiAcqua: true,
  },
  setCenter: (center) => set({ center }),
  setZoom: (zoom) => set({ zoom }),
  setSelectedFeatureId: (id) => set({ selectedFeatureId: id }),
  toggleLayer: (layerKey) =>
    set((state) => ({
      visibleLayers: {
        ...state.visibleLayers,
        [layerKey]: !state.visibleLayers[layerKey],
      },
    })),
}));